import {mapEntries} from '@logistics-frontend/utils'

import type {NddClaimPaymentMethod, PickupStation, PickupStationType} from 'src/shared/types'

import type {FilterFunction} from './types'

const isPostPayment = (payment: NddClaimPaymentMethod): boolean =>
  ['cash_on_receipt', 'card_on_receipt'].includes(payment)

export enum Filter {
  POST_PAYMENT = 'post_payment',
  POINT_TYPE = 'point_type',
}

export const filterFunctions: Record<Filter, FilterFunction> = {
  [Filter.POST_PAYMENT]: (value: PickupStation) => value.payment_methods.some(isPostPayment),
  [Filter.POINT_TYPE]: (value: PickupStation, type?: PickupStationType | boolean) => value.type === type,
}

export const INITIAL_VAlUES: Record<Filter, boolean> = mapEntries((_, value) => [value, false], Filter)
